import { TaboolaGraph } from 'taboola-ultimate-ui';

const { GRAPH_TYPE: GRAPH_TYPE_TUUI } = TaboolaGraph;

export const GRAPHS = {
    LINE: GRAPH_TYPE_TUUI.LINE,
    BAR: GRAPH_TYPE_TUUI.BAR,
    SINGLE_METRIC_LINE: 'SINGLE_METRIC_LINE',
};
